module.exports = __webpack_public_path__ + "img/service_zhichantuoguan.b7bdc31b.jpg";